import {
    SHOW_RETURNS_LOADER,
    WEB_GET_RETURNS_LINE_ITEMSREQUEST_SUCCESS,
} from 'yoda-site-components/lib/actionTypes/NativeAppActionTypes';
import {
    SET_MARKETPLACE_RETURN_ITEMS,
    SUBMIT_MARKETPLACE_RETURN_FAILURE,
    SUBMIT_MARKETPLACE_RETURN_SUCCESS,
    UPDATE_MARKETPLACE_RETURN_ITEM,
    CLEAR_RETURN_SUCCESS_FAILURE_INFO,
} from '../actionTypes/MarketplaceReturnActionTypes';

function MarketplaceReturnReducer(state = {}, action = {}) {
    switch (action.type) {
        case SET_MARKETPLACE_RETURN_ITEMS: {
            const items = [...action.payload.items];
            return { ...state, items };
        }
        case WEB_GET_RETURNS_LINE_ITEMSREQUEST_SUCCESS: {
            const { lineItems, ...otherParams } = action?.payload || {};
            return {
                ...state,
                items: lineItems,
                ...otherParams,
            };
        }
        case SHOW_RETURNS_LOADER: {
            return {
                ...state,
                showLoader: action.payload,
            };
        }
        case UPDATE_MARKETPLACE_RETURN_ITEM: {
            const { itemId, key, value } = action.payload;
            const updatedItems = state.items?.map((item) => {
                if (item?.product?.id === itemId) {
                    return {
                        ...item,
                        [key]: value,
                    };
                }
                return item;
            });
            return {
                ...state,
                items: updatedItems,
            };
        }

        case SUBMIT_MARKETPLACE_RETURN_SUCCESS: {
            console.log('action', action?.payload);
            return {
                ...state,
                ...action?.payload,
            };
        }
        case SUBMIT_MARKETPLACE_RETURN_FAILURE: {
            console.log('action', action?.payload);
            return {
                ...state,
                ...action?.payload,
            };
        }
        case CLEAR_RETURN_SUCCESS_FAILURE_INFO: {
            const {
                returnSucess,
                returnError,
                isReturnSuccess,
                isReturnError,
                ...newState
            } = state;
            return {
                ...newState,
            };
        }
        default:
            return state;
    }
}

MarketplaceReturnReducer.reducerName = 'marketplaceReturn';
export default MarketplaceReturnReducer;
